<template>
  <div v-if="shippingInfo" class="product-shipping">
    <!-- <div v-if="shippingInfo.deliveryTime" class="shipping-time">
      <b-icon icon="package-variant" class="mr-1" />
      <span>
        {{ $t('products.shippingInfo.deliveryTime', {time: getDeliveryTime()}) }}
      </span>
    </div>
    <div class="shipping-cost" :class="{'has-text-weight-bold': shippingInfo.shippingPrice.start < 0.01}">
      {{ $t(`products.shippingInfo.${shippingInfo.shippingPrice.start === 0 ? 'freeDelivery' : 'deliveryPrice'}`, {price: toCurrency(shippingInfo.shippingPrice.start, null, shippingInfo.shippingPrice.currency) }) }}
      {{ shippingInfo.typePrices === 'brutto' ? $t('fields.withVat') : $t('fields.withoutVat') }}
    </div> -->
    <div class="shipping-time">
      <b-icon icon="package-variant" class="mr-1" />
      <span>
        {{ $t(`products.shippingInfo.${shippingInfo.shippingPrice.start === 0 ? 'freeDelivery' : 'deliveryPrice'}`, {price: toCurrency(shippingInfo.shippingPrice.start, null, shippingInfo.shippingPrice.currency) }) }}
        {{ shippingInfo.typePrices === 'brutto' ? $t('fields.withVat') : $t('fields.withoutVat') }}

      </span>
    </div>
    <div v-if="shippingInfo.deliveryTime" class="shipping-cost has-text-weight-bold">
      {{ $t('products.shippingInfo.deliveryTime', {time: getDeliveryTime()}) }}
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      shippingInfo: null
    }
  },
  methods: {
    get (productId, quantity, check) {
      if (!check || (check && this.shippingInfo !== false)) {
        this.$api.default.getShippingInfo(productId, { quantity })
          .then((res) => {
            this.shippingInfo = res
          })
          .catch(() => {
            this.shippingInfo = null
          })
      }
    },
    set (val) {
      this.shippingInfo = val
    },
    getDeliveryTime () {
      let range = null
      if (this.shippingInfo && this.shippingInfo.deliveryTime) {
        const start = this.shippingInfo.deliveryTime.start
        const end = this.shippingInfo.deliveryTime.end
        if (this.$moment(start).isSame(end, 'year')) {
          if (this.$moment(start).isSame(end, 'month')) {
            if (this.$moment(start).isSame(end, 'day')) {
              range = this.$moment(start).format('dddd, DD MMM')
            } else { range = this.$moment(start).format('DD') + ' - ' + this.$moment(end).format('DD MMM') }
          } else { range = this.$moment(start).format('DD MMM') + ' - ' + this.$moment(end).format('DD MMM') }
        } else { range = this.$moment(start).format('DD.MM.YYYY') + ' - ' + this.$moment(end).format('DD.MM.YYYY') }
      }
      return range
    }
  }
}
</script>
